import React from "react";
import NoteItemAction from "./NoteItemAction";
import NoteItemBody from "./NoteItemContent";

function NoteItem({ title, date, body, id, onDelete, onArchive, archive }) {
  return (
    <div className="note-item">
      <NoteItemBody title={title} date={date} body={body} />
      <NoteItemAction id={id} onDelete={onDelete} onArchive={onArchive} archive={archive} />
    </div>
  );
}

export default NoteItem;
